import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth.service';
import { StationService } from 'src/app/modules/station/services/station.service';
import { ClickService } from 'src/app/services/click.service';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import { Observable, Subject, of } from 'rxjs';
import { takeUntil, finalize, timeout, catchError } from 'rxjs/operators';
import moment from 'moment';
import { VersionService } from 'src/app/services/version.service';
import { ProfileCacheService } from 'src/app/core/services/profile-cache.service';
import { ErrorService } from 'src/app/core/services/error.service';
import { hasOpeAccess } from 'src/app/utils/opeAccess';
import { DIVITSA_GROUP_ID } from 'src/app/utils/mermaAccess';
import { FuelOrdersService, isMobicoPipesAdmin, isMobicoPipesRequester } from 'src/app/modules/gasprecio/services/fuel-orders.service';
declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private profileLoading = false;

  @Input() pageSelection: string;
  @Output() toggle: EventEmitter<null> = new EventEmitter();
  alerts: any;
  amount = '950';
  arrayBuffer: any;
  brands = [];
  clienteActual: any;
  clientsList: any = [];
  creIdStation: any;
  email: any;
  dios = false;
  file: File;
  filterText: any;
  id: any;
  idGroup: any;
  idStation: any;
  isMobile = false;
  letters: any;
  name: any;
  newForm: UntypedFormGroup;
  notifications = false;
  // Pestaña «Pipas» del centro de notificaciones (Edey 27-oct): admin MOBICO = solicitudes por responder; solicitante =
  // respuestas de MOBICO. «Nuevo» = posterior a la última vez que el usuario abrió la pestaña (guardado en este navegador).
  readonly pipesRole: 'admin' | 'requester' | null = isMobicoPipesAdmin() ? 'admin' : (isMobicoPipesRequester() ? 'requester' : null);
  notifTab: 'prices' | 'pipes' = 'prices';
  pipesNotifs: any[] = [];
  /** Corte de «nuevo» con el que se pinta la lista abierta (el guardado se actualiza al abrirla). */
  pipesSeenView = 0;
  private readonly pipesProductLabels: { [key: string]: string } = { regular: 'Extra', premium: 'Supreme', diesel: 'Diésel' };
  private readonly pipesKindLabels: { [key: string]: string } = {
    addition: 'Adición', cancel: 'Cancelación', date: 'Cambio de fecha', capacity: 'Cambio de capacidad', product: 'Cambio de producto',
  };
  page$!: Observable<string>;
  page: string; // Current page selection
  plan1 = true;
  plan2: any;
  plan3: any;
  plan4: any;
  price = 950;
  profile: any;
  rol: any;
  route: any;
  showCharges = false;
  showCorpoconta = false;
  showDrop = false;
  showFlecha = false;
  showGestorpre = false;
  /** Ícono de Monitoreo: lo decide `monitor` del perfil (GASPRE_API); /v1/monitor lo exige igual. */
  puedeMonitorear = false;
  showGoenergy = false;
  showMenu = true;
  showEnerser = false;
  showOpe = false;
  showSuscripcion = false;
  station: any;
  stationForm: UntypedFormGroup;
  stationList: any = [];
  submitted = false;
  tax = '152';
  totalAmount = '1,102';
  waitList = false;
  stores = [
    { name: 'Oxxo' },
    { name: '7-Eleven' },
    { name: 'Extra' },
    { name: 'Circle K' },
    { name: 'Super city' },
    { name: 'Otro' }
  ];

  constructor(
    private gasprecioService: GasprecioService,
    public stationService: StationService,
    private clickService: ClickService,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthService,
    private router: Router,
    private sharedService: SharedService,
    private versionService: VersionService,
    private profileCacheService: ProfileCacheService,
    private errorService: ErrorService,
    private fuelOrders: FuelOrdersService
  ) {
    this.page$ = sharedService.sharedPage;
    const details = navigator.userAgent;
    const regexp = /android|iphone|kindle|ipad/i;
    const isMobileDevice = regexp.test(details);
    this.isMobile = isMobileDevice ? true : false;
    this.rol = localStorage.getItem('rol');
    this.idStation = localStorage.getItem('idStation');
    this.id = localStorage.getItem('id') ? localStorage.getItem('id') : '';
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.showOpe = hasOpeAccess(this.id);
    this.showEnerser = this.idGroup === '643f507358715227618de808' || this.idGroup === '649216f6edc3bad5497001f9' ? true : false;
    this.showFlecha = this.idGroup === '665a17634b4797a1fa1559b1';
    this.showGoenergy = this.idGroup === '668e85976102602768f02b7b';
    this.showCorpoconta = this.idGroup === '65d50dac037a5e0495e10c17';
    this.updateGestorpreVisibility();
    this.gasprecioService.getBrands(this.idGroup).subscribe((data: any) => {
      this.brands = data.map((element: any) => {
        element['name'] = this.gasprecioService.capitalizeFirstLetter(element['name']);
        return { name: element['name'], value: element['id'] };
      });
    });
  }

  async ngOnInit() {
    this.reset();
    this.sharedService.sharedPage.subscribe(val => this.page = val);
    this.stationForm = this.formBuilder.group({
      name: ['', Validators.required],
      cre: ['', Validators.required],
      location: ['', Validators.required],
      website: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      brand: ['', Validators.required],
      num_dispensaries: ['', Validators.required],
      inauguration: ['', Validators.required],
      type_conv_store: ['', Validators.required]
    });
    this.newForm = this.formBuilder.group({
      file: ['', Validators.required],
    });

    // Cargar perfil primero
    await this.getProfile();

    // Solo después de que el perfil esté listo, cargar otros datos
    // Esto previene errores de servicios que dependen del perfil
    this.profileCacheService.whenReady(() => {
      this.getStation();
      this.getAlerts();
      this.getPipesNotifications();
    });

    this.creIdStation = localStorage.getItem('creId') ? localStorage.getItem('creId') : this.authenticationService.creId;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.route = /[^/]*$/.exec(event.url)[0];
      }
    });
  }



  reset(): void {
    this.versionService.checkVersion();
  }

  getAlerts() {
    this.gasprecioService.getAlerts().subscribe((data: any) => {
      this.alerts = data;
      this.alerts.forEach((element: any) => {
        if (!element.click) {
          this.notifications = true;
        }
      });
    });
  }

  /** true si el usuario ve la pestaña «Precios» (el centro de siempre: Administrador / Dios). */
  get showPriceAlerts(): boolean {
    return this.rol === 'Administrador' || this.rol === 'Dios';
  }

  private get pipesSeenKey(): string {
    return `pipesNotifSeen:${this.id}`;
  }

  private get pipesSeenAt(): number {
    try { return +(localStorage.getItem(this.pipesSeenKey) || 0); } catch { return 0; }
  }

  getPipesNotifications(): void {
    if (!this.pipesRole) { return; }
    this.fuelOrders.getPipesNotifications().subscribe({
      next: (data) => {
        this.pipesNotifs = data?.items || [];
        this.pipesSeenView = this.pipesSeenAt;
      },
      error: () => { this.pipesNotifs = []; },
    });
  }

  /** Notificaciones de pipas posteriores a la última vez que se abrió la pestaña. */
  get pipesUnread(): number {
    const seen = this.pipesSeenAt;
    return this.pipesNotifs.filter((n) => new Date(n.ts).getTime() > seen).length;
  }

  isPipesNotifNew(n: any): boolean {
    return new Date(n.ts).getTime() > this.pipesSeenView;
  }

  /** Al abrir el sobre: si solo hay novedades de pipas, abre en esa pestaña; sin Precios, siempre en Pipas. */
  onNotificationsOpen(): void {
    this.clickPage('Notificaciones');
    if (!this.showPriceAlerts) {
      this.notifTab = 'pipes';
    } else if (this.pipesRole && !this.notifications && this.pipesUnread > 0) {
      this.notifTab = 'pipes';
    }
    if (this.notifTab === 'pipes') { this.markPipesSeen(); }
  }

  /** Cambio de pestaña dentro del dropdown (stopPropagation: el clic no debe cerrarlo). */
  selectNotifTab(tab: 'prices' | 'pipes', ev: MouseEvent): void {
    ev.stopPropagation();
    this.notifTab = tab;
    if (tab === 'pipes') { this.markPipesSeen(); }
  }

  /** Guarda «visto» ahora; la lista abierta conserva sus marcas de nuevo hasta la siguiente apertura. */
  private markPipesSeen(): void {
    this.pipesSeenView = this.pipesSeenAt;
    try { localStorage.setItem(this.pipesSeenKey, String(Date.now())); } catch { /* sin storage */ }
  }

  pipesKindLabel(kind: string): string {
    return this.pipesKindLabels[kind] || 'Solicitud';
  }

  pipesProductLabel(product: string): string {
    return this.pipesProductLabels[product] || product;
  }

  /** Litros y fecha requerida junto a los badges («20,000 L · 04/11»); la cancelación solo lleva la fecha. */
  pipesNotifMeta(n: any): string {
    const liters = n.liters && n.kind !== 'cancel' ? `${new Intl.NumberFormat('es-MX').format(n.liters)} L` : '';
    const day = n.delivery_date ? moment.utc(n.delivery_date).format('DD/MM') : '';
    return [liters, day].filter(Boolean).join(' · ');
  }

  /** Clic en una notificación de pipas: admin → panel de Solicitudes de MOBICO; solicitante → su vista de la estación. */
  openPipesNotification(n: any): void {
    if (this.pipesRole === 'requester' && n.station_id && this.gasprecioService.canOpenPipesStation(String(n.station_id))) {
      this.gasprecioService.openPipesStation(String(n.station_id));
      return;
    }
    const route = this.pipesRole === 'admin' ? '/gasprecio/general' : '/gasprecio/solicitud-pipas';
    const queryParams = this.pipesRole === 'admin' ? { view: 'pipes-request' } : {};
    this.router.navigate([route], { queryParams });
  }

  get f() { return this.stationForm.controls; }

  close(page: string) {
    $('#exampleModalCenter').modal('hide');

    setTimeout(() => {
      this.router.navigate([`/estacion/${page}`]);
    }, 400);
  }

  openSideBar() {
    this.toggle.emit();
  }

  show() {
    this.showDrop = !this.showDrop;
  }

  changeView(page: string) {
    if (page === 'menu') {
      this.showMenu = false;
      this.showSuscripcion = false;
    } else if (page === 'suscripcion') {
      this.showMenu = false;
      this.showSuscripcion = true;
    }
  }

  selectPlan(plan: number) {
    switch (plan) {
      case 1:
        this.plan1 = true;
        this.plan2 = false;
        this.plan3 = false;
        this.plan4 = false;
        this.amount = '950';
        this.price = 950;
        this.tax = '152';
        this.totalAmount = '1,102';
        break;
      case 2:
        this.plan1 = false;
        this.plan2 = true;
        this.plan3 = false;
        this.plan4 = false;
        this.price = 2500;
        this.amount = '2,500';
        this.tax = '400';
        this.totalAmount = '2,900';
        break;
      case 3:
        this.plan1 = false;
        this.plan2 = false;
        this.plan3 = true;
        this.plan4 = false;
        this.price = 2950;
        this.amount = '2,950';
        this.tax = '472';
        this.totalAmount = '3,422';
        break;
      case 4:
        this.plan1 = false;
        this.plan2 = false;
        this.plan3 = false;
        this.plan4 = true;
        this.price = 7500;
        this.amount = '7,500';
        this.tax = '1,200';
        this.totalAmount = '8,700';
        break;
      default:
        break;
    }
  }

  modalBuy() {
    Swal.fire({
      html: `<h2 style="color:#00e07b">Datos de pago</h2><p style="text-align: left">Medios de Pago: <strong>Transferencia o Depósito</strong> <br> Cuenta CLABE: <strong>012180001140999153</strong> <br> A nombre de: <strong>GASPREMIA S.A.DE C.V.</strong> <br> Referencia: <strong><i>	Escribe el nombre de tu Estación</i>	</strong> <br><br> Monto: <strong>$${this.amount} mxn.</strong>  <br> IVA: <strong>$${this.tax} mxn.</strong> <br> Monto Total: <strong>$${this.totalAmount}  mxn.</strong> <br><br> Enviar comprobante de pago a <a href="mailto:hola@gaspre.com"> hola@gaspre.com </a></p>`,
      confirmButtonColor: '#00e07b',
      confirmButtonText: 'Aceptar',
      showCloseButton: true
    }).then((result) => {
      if (result.value) {
        this.sendEmail();
      }
    });
  }

  sendEmail() {
    this.clickService.sendEmail(this.id, this.creIdStation, this.price)
      .pipe()
      .subscribe(
        data => {
          console.log(data);
        }
      );
  }

  changeCharges() {
    this.showCharges = !this.showCharges;
    this.showMenu = !this.showMenu;
  }

  resetView() {
    this.showMenu = true;
    this.showCharges = false;
  }

  changePage(page: string) {
    this.page = page;
    this.router.navigate(['/' + page.toLowerCase()]);
  }

  goTo(type: string, alert: any) {
    localStorage.setItem('creId', alert.cre);
    localStorage.setItem('idStation', alert.idStation);
    this.clearStoredGroup();
    this.alertRead(alert._id);
    switch (type) {
      case 'price_rules':
        this.router.navigate(['/gasprecio/reglas-precio']).then(() => {
          window.location.reload();
        });
        break;
      case 'price_changes':
        this.router.navigate(['/gasprecio/monitor']).then(() => {
          window.location.reload();
        });
        break;
      default:
        this.router.navigate(['/gasprecio/monitor']).then(() => {
          window.location.reload();
        });
        break;
    }
  }

  alertRead(idAlert: string, status?: string) {
    if (!status) {
      this.gasprecioService.alertRead(idAlert).subscribe(
        () => {
          this.notifications = false;
          this.getAlerts();
        });
    }
  }

  /**
   * Al cambiar de estación el grupo guardado deja de corresponder: si la estación
   * nueva es de otro grupo, los gates por grupo (Reporte Cruzado, Inventario…) se
   * calcularían con el grupo anterior. Se borra para que GroupGuard lo resuelva de
   * nuevo en la recarga.
   */
  private clearStoredGroup() {
    localStorage.removeItem('group');
  }

  changeClient(cliente: any) {
    this.clienteActual = cliente.alias;
    localStorage.setItem('creId', cliente.cre);
    localStorage.setItem('idStation', cliente._id);
    this.clearStoredGroup();
    window.location.reload();
  }

  changeClientG(cliente: any) {
    localStorage.setItem('creId', cliente.cre);
    localStorage.setItem('idStation', cliente._id);
    this.clearStoredGroup();
    this.clienteActual = cliente.alias;
    this.route = 'monitor';
    this.router.navigate(['/gasprecio/monitor']).then(() => {
      window.location.reload();
    });
  }

  changeClientGestorpre(cliente: any) {
    localStorage.setItem('creId', cliente.cre);
    localStorage.setItem('idStation', cliente._id);
    this.clearStoredGroup();
    this.clienteActual = cliente.alias;
    this.route = 'gestorpre';
    this.router.navigate(['/gasprecio/gestorpre']).then(() => {
      window.location.reload();
    });
  }

  async getProfile(): Promise<void> {
    // Prevenir múltiples llamadas simultáneas
    if (this.profileLoading) {
      return;
    }

    this.profileLoading = true;

    // Determinar si el usuario es "Dios"
    if (this.rol === 'Dios') {
      this.dios = true;
    } else {
      // Si no hay idGroup, obtenerlo primero
      if (!this.idGroup) {
        try {
          await this.getIdGroup();
        } catch (error) {
          console.error('Error obteniendo idGroup:', error);
          this.profileLoading = false;
          return;
        }
      }
    }

    // Usar el servicio de caché para obtener el perfil
    this.stationService.getProfile(this.dios, this.idGroup)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.profileLoading = false)
      )
      .subscribe({
        next: (data) => {
          // getStation() ya se dispara desde ngOnInit vía profileCacheService.whenReady;
          // llamarlo también aquí duplicaba el request a /crm/stations/:id en cada carga
          this.processProfileData(data);
        },
        error: (err) => {
          console.error('Error cargando perfil:', err);
          this.errorService.handle(err);
        }
      });
  }

  /**
   * Procesa los datos del perfil recibidos del servidor
   */
  private processProfileData(data: any): void {
    this.puedeMonitorear = data.monitor === true;
    // Actualizar rol
    if (data.rol) {
      localStorage.setItem('rol', data.rol);
      this.rol = data.rol;
    }

    // Procesar estaciones
    if (data.stations && data.stations.length > 0) {
      data.stations.forEach((element: any, index: number) => {
        if (this.rol === 'Gaspre') {
          element['alias'] = 'Tu estación ' + (index + 1);
        } else if (!element['alias']) {
          // alias es opcional en BD: sin este fallback una estación sin alias
          // rompe el render del dropdown y el buscador (toLowerCase de undefined)
          element['alias'] = element['name'] || '';
        }
      });

      this.clientsList = data.stations;
      this.stationList = data.stations;
      localStorage.setItem('stations', JSON.stringify(this.clientsList));

      // Verificar si la estación actual está en la lista
      const currentStation = this.clientsList.find((c: any) => c._id === this.idStation);
      if (currentStation) {
        this.clienteActual = currentStation.alias;
      } else {
        // Si no está, usar la primera estación y recargar
        this.clienteActual = this.clientsList[0].alias;
        localStorage.setItem('creId', this.clientsList[0].cre);
        localStorage.setItem('idStation', this.clientsList[0]._id);
        this.clearStoredGroup();
        // Evitar reload innecesario, mejor navegar
        this.router.navigate(['/gasprecio/monitor']).then(() => {
          window.location.reload();
        });
        return;
      }
    }

    // Actualizar información del usuario
    if (data.email) this.email = data.email;
    if (data.name) {
      this.name = data.name;
      // Generar iniciales
      this.letters = this.name.concat(' ')
        .replace(/([a-zA-Z]{0,} )/g, (match: any) => (match.trim()[0]))
        .slice(0, 2);
    }

    if (data._id) {
      localStorage.setItem('id', data._id);
      this.id = data._id;
    }

    if (data.idStation) {
      this.idStation = data.idStation;
    }

    this.updateGestorpreVisibility();
  }

  getIdGroup() {
    return new Promise<void>((resolve, reject) => {
      this.stationService.getStationProfile().subscribe(
        data => {
          this.idGroup = data.station.group;
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getStation() {
    this.stationService.getStationProfile().subscribe(
      data => {
        this.station = data.station;
        this.idGroup = this.station.group;
        if (this.idGroup?.length > 0) {
          localStorage.setItem('group', this.station.group);
          this.sharedService.nextGroup = this.station.group;
        }
        this.updateGestorpreVisibility();
        if (this.station['custom']['schedule_notifications']) {
          localStorage.setItem('from', this.station['custom']['schedule_notifications']['from']);
          localStorage.setItem('until', this.station['custom']['schedule_notifications']['until']);
        }

        if (this.station['custom']['marketer']) {
          localStorage.setItem('marketer', this.station['custom']['marketer']);
        }

        if (this.station.name) {
          this.stationForm.patchValue({
            name: this.station.name,
          });
        }

        if (this.station.waiting_list) {
          this.waitList = this.station.waiting_list;
        }

        if (this.station.cre) {
          this.stationForm.patchValue({
            cre: this.station.cre,
          });
        }

        if (this.station.location) {
          this.stationForm.patchValue({
            location: this.station.location,
          });
        }

        if (this.station.website) {
          this.stationForm.patchValue({
            website: this.station.website,
          });
        }

        if (this.station.phone) {
          this.stationForm.patchValue({
            phone: this.station.phone,
          });
        }

        if (this.station.email) {
          this.stationForm.patchValue({
            email: this.station.email,
          });
        }

        if (this.station.brand) {
          this.stationForm.patchValue({
            brand: this.station.brand,
          });
        }

        if (this.station.num_dispensaries) {
          this.stationForm.patchValue({
            num_dispensaries: this.station.num_dispensaries,
          });
        }

        if (this.station.inauguration) {
          this.stationForm.patchValue({
            inauguration: this.station.inauguration,
          });
        }

        if (this.station.type_conv_store) {
          this.stationForm.patchValue({
            type_conv_store: this.station.type_conv_store,
          });
        }
      },
      error => {
        console.log(error);
      });
  }

  editStation() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.stationForm.invalid) {
      return;
    }

    this.stationService.updateStationProfile(this.f.name.value, this.f.location.value, this.f.website.value, this.f.email.value, this.f.phone.value, this.f.type_conv_store.value, this.f.inauguration.value, this.f.num_dispensaries.value, this.f.brand.value)
      .pipe()
      .subscribe({
        next: () => {
          this.gasprecioService.displayMessage('success', 'Información actualizada!', 'La estación ha sido actualizado con éxito.')
        },
        error: () => {
          this.gasprecioService.displayMessage('error', 'Error', 'La estación no ha sido actualizada con éxito.')
        }
      });
  }

  get n() { return this.newForm.controls; }

  loadFile(event: any) {
    this.file = event.target.files[0];
  }

  uploadFile() {
    // stop here if form is invalid
    if (this.newForm.invalid) {
      return;
    }

    this.gasprecioService.showLoader('Subiendo información', 'Por favor, aguarda un momento...');
    this.stationService.uploadChargeRecord(this.file)
      .subscribe({
        next: (data) => {
          Swal.hideLoading();
          if (data.err.message === 'Record already exists') {
            const charges = data.err.total_charges;
            this.confirmOverwrite(this.file, charges);
          } else {
            this.gasprecioService.displayMessage('success', '¡El archivo se ha subido con éxito!')
          }
        },
        error: () => {
          this.gasprecioService.displayMessage('error', 'Error', 'Hubo un error al cargar el archivo')
        }
      });
  }

  confirmOverwrite(file: any, charges: any) {
    Swal.fire({
      title: '¿Estás seguro que deseas sobrescribir las cargas?',
      text: `Ya existen ${charges} cargas`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#00e07b',
      cancelButtonColor: '#fa1975',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      confirmButtonText: 'Si, sobrescribir'
    }).then((result) => {
      if (result.value) {
        this.stationService.overwriteChargeRecord(file)
          .subscribe({
            next: () => {
              this.gasprecioService.displayMessage('success', '¡El archivo se ha sobrescrito con éxito!')
            },
            error: () => {
              this.gasprecioService.displayMessage('error', 'Error', 'Hubo un error al sobrescribir el archivo')
            }
          });
      }
    });
  }

  clickPage(page: string) {
    this.clickService.clickPage(this.id, this.idStation, page, this.page)
      .pipe()
      .subscribe(
        data => {
          console.log(data)
        });
  }

  resetMarketIntelligence() {
    this.sharedService.resetMarketIntelligence();
  }

  modalWaitList() {
    Swal.fire({
      html: `<p style="font-weight:bold"> ¿Quieres ser de los primeros en utilizar esta gran herramienta? </p> <p> Registrate y se de los primeros usuarios en probarlo  </p>`,
      footer: '<p>Si deseas obtener más información da click <a style="color:#00e07b" href="https://www.gaspremia.com" target="_blank"> aquí </a></p>',
      icon: 'warning',
      reverseButtons: true,
      confirmButtonColor: '#00e07b',
      confirmButtonText: 'Registrarme',
      showCancelButton: true,
      cancelButtonColor: '#b82f26',
      cancelButtonText: 'Después',
      showCloseButton: true
    }).then((result) => {
      if (result.value) {
        this.addWaitList();
      }
    });
  }

  addWaitList() {
    this.clickService.addWaitList(this.id, this.idStation)
      .pipe()
      .subscribe(
        () => {
          Swal.fire({
            title: 'Has sido añadido a la lista de espera de GasPremia',
            footer: '<p>Si deseas obtener más información da click <a style="color:#00e07b" href="https://www.gaspremia.com" target="_blank"> aquí </a></p>',
            icon: 'success',
            confirmButtonColor: '#00e07b',
            confirmButtonText: 'Aceptar',
          });
        });
  }

  /**
   * Registra el click de "Salir" y cierra la sesión con una carga completa del
   * documento (ver AuthService.leaveToLogin). Se espera el ping de tracking
   * —a lo más 1 s— porque al tirar el documento el navegador cancela las
   * peticiones en vuelo; si falla o tarda, se sale igual.
   */
  logout() {
    const leave = () => this.authenticationService.leaveToLogin();
    this.clickService.clickPage(this.id, this.idStation, 'Salir', this.page)
      .pipe(timeout(1000), catchError(() => of(null)))
      .subscribe({ next: leave, error: leave });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  capitalizeFirstLetter(text: string) {
    if (!text) {
      return '';
    }
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  /**
   * Normaliza texto para búsqueda: minúsculas y sin acentos, para que
   * "chipitlan" encuentre "Chipitlán".
   */
  private normalizeSearchText(text: string): string {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  filterItem(str: string) {
    if (typeof str === 'string') {
      const search = this.normalizeSearchText(str);
      this.clientsList = this.stationList.filter((d: any) =>
        this.normalizeSearchText(d['alias']).indexOf(search) !== -1
      );
    }
  }

  /**
   * Limpia el buscador al abrir/cerrar el dropdown de estaciones para que
   * la lista no se quede filtrada de una apertura anterior.
   */
  resetFilter() {
    this.filterText = '';
    this.clientsList = this.stationList;
  }

  clickIcon(type) {
    let page = this.page;
    if (page === 'General') {
      page = 'Tablero'
    } else if (page === 'Mercado') {
      page = 'Modulo Inteligencia'
    }

    if (type !== page) {
      this.clickPage(type)
    }

  }

  getCrossUser() {
    const date = moment()
      .tz('America/Mexico_City')
      .format('YYYY-MM-DDTHH:mm:ss');

    this.gasprecioService
      .getCrossUser({ cre: this.creIdStation, date })
      .subscribe(
        data => {
          console.log('respuesta cross_user:', data);
          if (data.exists === false && data.redirect) {
            window.open(data.redirect, '_blank');
          }
          else if (data.exists === true && data.redirect && data.user) {
            // Si existe, añadimos user completo como query param
            const userParam = btoa(JSON.stringify(data));
            const url = `${data.redirect}?code=${userParam}`;
            window.open(url, '_blank');
          }
        },
        err => console.error(err)
      );
  }

  private updateGestorpreVisibility(): void {
    this.showOpe = hasOpeAccess(this.id);
    this.showGoenergy = this.idGroup === '668e85976102602768f02b7b';
    this.showCorpoconta = this.idGroup === '65d50dac037a5e0495e10c17';
    // Divitsa ve Mermas y OPE en el Tablero (junta 26-oct): en Gestorpre ya no le queda nada.
    this.showGestorpre = (this.showGoenergy || this.showOpe || this.showCorpoconta) && this.idGroup !== DIVITSA_GROUP_ID;
  }
}
